// OtpModal.jsx — backend /api/auth/verify-otp call பண்றோம்
import React, { useEffect, useState } from "react";
import "./OtpModal.css";
import { IoClose } from "react-icons/io5";
import { toast } from "react-toastify";
import API from "../../../../Api/api";

const OtpModal = ({
  otpModal,
  setOtpModal,
  otpType,       // 'login' | 'signup' | 'forgot' | 'phone'
  otpPin,        // dev mode-ல் மட்டும் use — real mode-ல் backend verify
  setVerified,
  email,         // backend verify-க்கு email தேவை
  onResend,      // parent-ல் resend logic (optional)
}) => {
  const [otpTimer, setOtpTimer] = useState(120);
  const [otpValue, setOtpValue] = useState("");
  const [loading,  setLoading]  = useState(false);

  // Timer
  useEffect(() => {
    let interval;
    if (otpModal && otpTimer > 0)
      interval = setInterval(() => setOtpTimer(p => p - 1), 1000);
    return () => clearInterval(interval);
  }, [otpModal, otpTimer]);

  const closeOtpModal = () => {
    setOtpModal(false);
    setOtpValue("");
    setOtpTimer(120);
  };

  const formatTime = (sec) => {
    const m = Math.floor(sec / 60);
    const s = sec % 60;
    return `${m}:${s < 10 ? "0" + s : s}`;
  };

  const resendOtp = () => {
    if (otpTimer > 0) return;
    if (onResend) onResend();
    setOtpTimer(120);
    setOtpValue("");
  };

  const handleOtpVerify = async () => {
    if (!otpValue)             { toast.error("OTP is required!"); return; }
    if (otpValue.length !== 6) { toast.error("OTP must be 6 digits!"); return; }

    setLoading(true);
    try {
      // ── Case 1: dev mode — otpPin இருந்தா local compare ──
      if (otpPin && otpPin.toString().length === 6) {
        if (otpValue.trim() !== otpPin.toString().trim()) {
          toast.error("Invalid OTP! Please try again.");
          setLoading(false);
          return;
        }
        toast.success("OTP Verified Successfully!");
        setVerified(prev => ({ ...prev, [otpType]: true }));
        closeOtpModal();
        return;
      }

      // ── Case 2: real email OTP — backend verify ──
      // purpose mapping: 'login'→'login', 'signup'→'signup', 'forgot'→'forgot'
      const purpose = ['login','signup','forgot'].includes(otpType) ? otpType : 'signup';

      await API.post('/auth/verify-otp', {
        email:   email,
        otp:     otpValue.trim(),
        purpose,
      });

      toast.success("OTP Verified Successfully!");
      setVerified(prev => ({ ...prev, [otpType]: true }));
      closeOtpModal();

    } catch (err) {
      toast.error(err.response?.data?.error || "Invalid OTP! Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (!otpModal) return null;

  return (
    <div className="otp-modal-overlay">
      <div className="otp-modal">
        <button className="otp-close-icon" onClick={closeOtpModal}>
          <IoClose />
        </button>
        <h3>OTP Verification</h3>
        <p>Enter OTP sent to your <b>{email || otpType}</b></p>
        <input
          type="text"
          placeholder="Enter 6-digit OTP"
          value={otpValue}
          onChange={e => setOtpValue(e.target.value)}
          maxLength={6}
          onKeyDown={e => { if (e.key === 'Enter') handleOtpVerify(); }}
          autoFocus
        />
        <p className="otp-timer">Time Remaining: <b>{formatTime(otpTimer)}</b></p>
        <div className="otp-actions">
          <button type="button" className="otp-submit-btn" onClick={handleOtpVerify} disabled={loading}>
            {loading ? "Verifying…" : "Verify OTP"}
          </button>
          <button
            type="button"
            className={`otp-resend-btn ${otpTimer > 0 ? "disabled-btn" : ""}`}
            onClick={resendOtp}
            disabled={otpTimer > 0}
          >
            Resend OTP
          </button>
        </div>
      </div>
    </div>
  );
};

export default OtpModal;